<template>
  <OptionSummary></OptionSummary>
  <section class="section-followers">
    <div class="title">
      <h2>دنبال کنندگان</h2>
      <hr class="title-separator" />
    </div>
    <template v-for="(follower, index) in followersList" :key="index">
      <followerCard :follower="follower"></followerCard>
    </template>
  </section>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
import followerCard from "@/components/followerCard/index.vue";
import { followersData } from "@/repo/followersData";
export default {
  name: "followersPage",
  components: {
    OptionSummary,
    followerCard,
  },
  mixins: [followersData],
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/followers/followers.css);
</style>